import { AfterViewInit, Component, forwardRef, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { LMNavigationService } from '@navigation/lm-navigation.service';
import {
  LMBusyIndicatorService,
  LMComponentInfoService,
  LMContextService,
  LMModalOpenService,
  LMModalWrapperService,
  LMRouteComponentService,
  LMUrlUtilService
} from '@app/services';
import { LMBannerHeaderComponentRef, LMBaseComponent, SaveRequired } from '@app/components';
import { first } from 'rxjs/operators';
import { LMUniqueIdService } from '@app/utils';
import { LMAppComponentService } from '@utils/lm-app-component.service';

@Component({
  selector: 'lm-action',
  standalone: false,
  template: `
    <div><span>{{ 'Loading' | translate }}</span></div>`,
})

export class LMActionComponent extends LMBaseComponent implements OnInit, AfterViewInit, SaveRequired {

  public isRouterOutletRootComponent = false;
  public bannerInRoute = false;
  constructor(
    private router: Router,
    private currentComponent: LMRouteComponentService,
    private lmNavigationService: LMNavigationService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    private lmContextService: LMContextService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmAppComponentService: LMAppComponentService,
    @Inject(forwardRef(() => LMBannerHeaderComponentRef)) private lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    protected lmModalWrapperService: LMModalWrapperService,
    protected  lmModalOpenService: LMModalOpenService
  ) {
    super(lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);
  }

  ngOnInit() {
    if (!this.lmContextService.inMingleWidget()) {
      this.isRouterOutletRootComponent = true;
      this.currentComponent.setRouteComponent(this as Component);
    }
  }

  ngAfterViewInit() {
    this.redirect(this.router.url);
  }

  redirect(actionUrl: string) {
    // Used by:
    // 1. Inbox Notification Drillbacks
    // 2. Mingle Overlays
    this.lmUrlUtilService.updateUrlParams(actionUrl, { output: 'spec' });
    const isNotificationDrillBack = this.lmUrlUtilService.hasParam(actionUrl, 'InboxNotificationDrillback');
    if (isNotificationDrillBack) {
      this.lmNavigationService.runNotificationAction(actionUrl, { skipLocationChange: true }).pipe(first()).subscribe(b => {
        // b is true for pdf, csv and any error
        // Content area will remain empty after the download. The user can interact with menu to navigate to other places
        // b is false for other list, form, page navigations. The busy indicator and title will be managed by the components.
        if (b) {
          // NavigationStart in form or list or page components will start the busy indicator,
          // as the drillback is processed and routes to an action url
          // PDF will open a new window and CSV downloads. Hide busy indicator is required for document type.
          // Other action redirect types will navigate to form or list or page component which again will start the busy indicator
          this.lmBusyIndicatorService.hideBusyIndicator();
          // Clear the banner title for PDF/CSV.
          if (this.isRouterOutletRootComponent && !this.bannerInRoute) {
            this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = '';
          }
        }
      });
    } else {
      // This request is from Inbox for action requests.
      // Action controller loads action request dataview, so show the busy indicator now.
      // It will be dismissed by the form component once the dataview is loaded.
      this.lmBusyIndicatorService.showBusyIndicator();
      this.lmNavigationService.runNavigation(actionUrl, undefined, { replaceUrl: true });
    }
  }

  checkSaveRequired(fromUnifiedMenu?: boolean) {
    return false;
  }

  public allowPageNavigation(): Promise<boolean> {
    return Promise.resolve(true);
  }

  displayNavigationConfirmation(): Promise<boolean> {
    return Promise.resolve(true);
  }

  displayUnsavedChanges(): Promise<boolean> {
    return Promise.resolve(true);
  }

  modalOpen(): boolean {
    return false;
  }

  modalNavigationBlocked(fromUnifiedMenu?: boolean) {
    return false;
  }

  saveComponentState(includeSubComponents?: boolean): void {
  }

  public getComponentInfo(additionInfo?: LMCompInfoAdditionalInfo): LMComponentInfo | undefined {
    return undefined;
  }

  public getComponentPlaceHolder(): ViewContainerRef | undefined {
    return undefined;
  }

  public getUserWebRequestId(): string {
    return 'ActionComponent-' + this.getBaseCompId();
  }
}
